import { render, staticRenderFns } from "./ManageBalance.vue?vue&type=template&id=6cdfbe3c&scoped=true&"
import script from "./ManageBalance.vue?vue&type=script&lang=js&"
export * from "./ManageBalance.vue?vue&type=script&lang=js&"
import style0 from "./ManageBalance.vue?vue&type=style&index=0&id=6cdfbe3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdfbe3c",
  null
  
)

export default component.exports